import React from "react";
import Typography from "@material-ui/core/Typography";

const H3 = (props: any) => (
  <Typography variant="h3" component="h3" gutterBottom {...props} />
);

export default H3;
